import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateProjectTagsQuery = (projectId: number) => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['get:projects/tags', projectId],
    });
  }, [projectId, queryClient]);
};
